export interface TrainingData {
  name: string;
  isConfirmReviewed: boolean;
}

export const createTrainingData = (): TrainingData => ({
  name: "",
  isConfirmReviewed: false,
});
